/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_add_team_email_label = /** @type {(inputs: {}) => string} */ () => {
	return `Correo electrónico`
};

const en_organization_add_team_email_label = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_add_team_email_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_add_team_email_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_add_team_email_label", locale)
	if (locale === "es") return es_organization_add_team_email_label(inputs)
	return en_organization_add_team_email_label(inputs)
};
export { organization_add_team_email_label as "organization.add_team.email_label" }